var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "collection__products-item product-item",
      on: {
        mouseover: function ($event) {
          _vm.rollover = true
        },
        mouseleave: function ($event) {
          _vm.rollover = false
        },
      },
    },
    [
      _c("a", { staticClass: "product-item__link", attrs: { href: _vm.url } }, [
        _c(
          "div",
          {
            staticClass: "product-item__image-wrapper lazy-container",
            staticStyle: { "--aspect-ratio": "1" },
            on: {
              mouseover: function ($event) {
                _vm.hover = true
              },
              mouseleave: function ($event) {
                _vm.hover = false
              },
            },
          },
          [
            _c("transition", { attrs: { name: "fade" } }, [
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeImage,
                    expression: "activeImage",
                  },
                ],
                ref: "image",
                staticClass: "lazyload",
                class: {
                  lazyload: _vm.hover,
                  "remove-transition": _vm.lazyloaded,
                },
                attrs: { "data-src": _vm.activeImage, alt: _vm.product.title },
              }),
            ]),
            _vm._v(" "),
            _vm.lazyloaded < 3
              ? _c(
                  "div",
                  {
                    staticClass: "site-loading",
                    class: { activated: _vm.hover },
                  },
                  [_vm._m(0)]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("transition", { attrs: { name: "fade" } }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hoverDescription && _vm.hover,
                      expression: "hoverDescription && hover",
                    },
                  ],
                  staticClass: "product-item__hover-description",
                },
                [_c("p", [_vm._v(_vm._s(_vm.hoverDescription))])]
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c("span", { staticClass: "product-item__title" }, [
          _vm._v("\n      " + _vm._s(_vm.product.title) + "\n    "),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "product-item__price" }),
        _vm.price
          ? _c("div", { domProps: { innerHTML: _vm._s(_vm.price) } })
          : _vm._e(),
        _vm._v(" "),
        _c("p"),
        _vm._v(" "),
        _c("button", { staticClass: "btn btn--secondary" }, [_vm._v("Buy")]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "half-circle-spinner" }, [
      _c("div", { staticClass: "circle circle-1" }),
      _vm._v(" "),
      _c("div", { staticClass: "circle circle-2" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }